import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import UserTable from './_components/UserTable'
import OfaOverviewModal from './_components/OfaOverviewModal'
import { selectShowOfaFeatures } from '../../services/utils/appInfoSlice'
import QuestionsUploader from '../../components/_questions/QuestionsUploader'

import check_img from './images/check.svg'
import waiting_img from './images/clock.svg'
import user_image from '../../assets/images/user.svg'
import users_image from '../../assets/images/users.svg'
import lock_image from './images/lock.svg'
import settings_img from '../../assets/images/nav_icons/settings.svg'

import { useTour } from "@reactour/tour"
import { selectUserData, selectUserOnboarding } from "../../features/User/userSlice"
import { usersTourSteps } from "../../config/tour"

import './UserSettings.css'


export default function UserHomeScreen () {

    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const [statusFilter, setStatusFilter] = useState("all")
    const [showOfaOverview, setShowOfaOverview] = useState(false)
    const showOfaFeatures = useSelector(selectShowOfaFeatures)
    // null, 'create_pre_registered_users_from_excel' or 'add_user_groups_from_excel'
    const [excelImport, setExcelImport] = useState(null)
    const [filter, setFilter] = useState({
        deleted: false,
        active: false,
        suspended: false,
        waiting: false,
        is_admin: false,
        skip: 0,
        limit: 20
    })

    const changeStatusFilter = (e) => {
        switch(e.target.value){
            case 'all' : {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: false,
                    suspended: false,
                    waiting: false,
                    is_admin: false,
                })
            } break;
            case 'waiting' : {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: false,
                    suspended: false,
                    waiting: true,
                    is_admin: false,
                })
            } break;
            case 'active' : {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: true,
                    suspended: false,
                    waiting: false,
                    is_admin: false,
                })
            } break;
            default: {
                setFilter({
                    ...filter,
                    deleted: false,
                    active: false,
                    suspended: false,
                    waiting: false,
                    is_admin: false,
                })
            }
        }
        setStatusFilter(e.target.value)
    }

    const userOnboarding  = useSelector(selectUserOnboarding)
    const userData = useSelector(selectUserData)
    const { setIsOpen, setCurrentStep, setSteps, setMeta } = useTour()
    
    useEffect(()=>{
        if(!userData?.is_super_admin){
            if(!userOnboarding?.users?.section_completed && userOnboarding?.users?.step_completed_count <= 1){
                setTimeout(()=>{
                    if(window.location.pathname?.includes("users"))
                        setIsOpen(true)
                },2000)
                setSteps(usersTourSteps(navigate))
                setCurrentStep(userOnboarding?.users?.step_completed_count)
                setMeta('users')
            } else if(userOnboarding?.users?.step_completed_count === 2 && !userOnboarding?.users?.section_completed){
                navigate("/users/groups")
            } 
        }
        
    },[])



    return(
        <section id="usersScreen">
            <div className='d-flex align-items-center justify-content-between'>
                <div className='d-flex'>
                    <div className="page_title active">
                        <img src={user_image} />
                        <h1>{t.users.users}</h1>
                    </div>
                    <NavLink to={'/users/groups'}>
                        <div className="page_title not_active ms-4">
                            <img src={users_image} />
                            <h1>{t.users.groups}</h1>
                        </div>
                    </NavLink>
                    <NavLink to={'/users/admins'}>
                        <div className="page_title not_active ms-4">
                            <img src={lock_image} />
                            <h1>{t.users.admin}</h1>
                        </div>
                    </NavLink>
                </div>
                <div className='d-flex align-items-center'>
                    {showOfaFeatures && <button className='secondary me-2' onClick={()=>setShowOfaOverview(true)}>{t.ofa.overview}</button>}
                    <button className='secondary' onClick={()=>setExcelImport('create_pre_registered_users_from_excel')}>{t.users.excel.import_users}</button>
                    <button className='secondary ms-2' onClick={()=>setExcelImport('add_user_groups_from_excel')}>{t.users.excel.add_groups}</button>
                    <NavLink to={'/users/settings'} state={{from: location.pathname }}>
                        <div className="page_title not_active ms-4">
                            <img src={settings_img} />
                        </div>
                    </NavLink>
                </div>
            </div>
            <div className='mt-3 users-step-0'>
                <div className='d-flex mb-3'>
                    <div className='custom-radio'>
                        <input type="radio" id="1" name="statusFilter" value="all" checked={statusFilter === "all"} onChange={changeStatusFilter}/>
                        <label htmlFor="1">
                            {t.users.all}
                        </label>
                    </div>
                    <div className='custom-radio ms-2'>
                        <input type="radio" id="2" name="statusFilter" value="waiting" checked={statusFilter === "waiting"} onChange={changeStatusFilter} />
                        <label htmlFor="2">
                            <img src={waiting_img} className="me-1" />
                            {t.users.waiting}
                        </label>
                    </div>
                    <div className='custom-radio ms-2'>
                        <input type="radio" id="3" name="statusFilter" value="active" checked={statusFilter === "active"} onChange={changeStatusFilter}/>
                        <label htmlFor="3">
                            <img src={check_img} className="me-1" />
                            {t.users.accepted}
                        </label>
                    </div>
                </div>
                <UserTable defaultFilters={filter}/>
            </div>
            <OfaOverviewModal show={showOfaFeatures && showOfaOverview} onClose={()=>setShowOfaOverview(false)} />
            {excelImport &&
                <QuestionsUploader
                    key={excelImport}
                    show={true}
                    onClose={()=>setExcelImport(null)}
                    endpoint={`/admin/${excelImport}`}
                    title={t.users.excel[excelImport]}
                    description={t.users.excel.format_description}
                    successMessage={t.users.excel.import_success}
                    onUploadComplete={()=>setFilter({...filter})}
                />
            }
        </section>
        
    )
}